import React, { FC } from 'react'
import WelcomeContent from '../../components/WelcomeContent'

type AuthenticationPageProps = {}
const SignupPage: FC<AuthenticationPageProps> = ({ children }) => {
  return (
    <div className='authentication'>
      <WelcomeContent />
      {children}
    </div>
  )
}

export default SignupPage
